<div gs1Modal
     width="615"
     title=""
     [customHtml]="customHtml"
     [confirm]="CONFIRM_BT_TXT"
     [confirmDisabled]="false"
     (closed)="validateWarning($event)"
     [closeButton]="true"
     [disableClose]="true"
     #directiveRef="gs1Modal"
>
</div>
